<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiPaperclip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Annual Check-Up Approval Result
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-container>
        <v-container v-if="getACUResult.OPAN_N" :style="`padding: ${screen_width > 959 ? '0 30px' : screen_width > 599 ? '0' : '0'};`">
            <v-card :style="`padding: ${screen_width > 599 ? '10px 20px' : '0'}`">
                <v-alert
                    text
                    color="#4ABAA4"
                    style="border-left: 8px solid #4ABAA4;"
                >
                    <div style="color: black; text-align: justify;">
                        Your request for annual check up on {{ getACUResult.CLINIC_NAME }} was approved.
                        The approved eOPAN is now available for download by clicking the button below.
                        The eOPAN will also be sent in your registered email or can be downloaded from the History page. This eOPAN is issued {{ moment(getACUResult.APPR_D).format('DD MMMM YYYY') }} and is valid until {{ moment(getACUResult.VALI_D).format('DD MMMM YYYY') }}.
                    </div>
                </v-alert>
                <v-row :style="`margin: ${screen_width > 599 ? '10px 17px' : '10px 0'};`">
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">OPPA NO:</span><b>{{ getACUResult.OPAN_N }}</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">Status:</span><b style="color: #00BA94;">{{ getACUResult.APPROVE ? 'APPROVED' : 'DISAPPROVED' }}</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-divider class="d-sm-none my-3" /><span style="display: block; color: #555;">Date Issued:</span><b>{{ formatDate(getACUResult.APPR_D) }}</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">Valid Until:</span><b>{{ formatDate(getACUResult.VALI_D) }}</b>
                    </v-col>
                </v-row>
                <v-card :style="`padding: ${screen_width > 599 ? '28px' : '0 10px'}; background-color: #F9F9F9;`">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <span style="display: block; color: #555;">Medical Provider:</span><b>{{ getACUResult.CLINIC_NAME }}</b>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-divider class="d-sm-none my-3" />
                            <div>
                                <span style="display: block; color: #555;">Patient Name:</span><b>{{ getACUResult.MEMB.LAST_M }}</b>
                            </div>
                            <div class="mt-4">
                                <span style="display: block; color: #555;">Date of Birth:</span><b>{{ formatDate(getACUResult.MEMB.BIRT_D) }}</b>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <p :style="`margin: ${screen_width > 599 ? '28px' : '30px 10px 10px 10px'}; font-size: 16px; color: #222; text-align: justify;`">
                    <v-icon color="orange">
                        {{ mdiAlert }}
                    </v-icon>&nbsp;Disclaimer: The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.
                </p>
                <v-container v-if="getACUResult.OPAN_N" style="text-align: center;">
                    <v-btn class="teal white--text" style="margin: 10px;" @click="getSlip">
                        <v-icon>{{ mdiDownload }}</v-icon>&nbsp;
                        <h1>Download</h1>
                    </v-btn>
                    <v-btn @click="goBack()">
                        <h1>Done</h1>
                    </v-btn>
                    <h1 style="color: #00BA94;">
                        Should you need assistance, kindly contact <a style="color: #00BA94" href="https://www.hmi.com.ph/contact">HMI</a>.
                    </h1>
                </v-container>
            </v-card>
        </v-container>
    </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { saveAs } from 'file-saver'
import { moment } from '../../../utils/date-shim'
import { mdiAlert, mdiDownload, mdiPaperclip } from '@mdi/js'
import { base64ToBlob } from '../../../utils/helpers'
export default {
    data: () => {
        return({
            mdiAlert, 
            mdiDownload, 
            mdiPaperclip,
            opan_n: '',
            screen_width: document.documentElement.clientWidth + 9
        })
    },
    computed: {
        ...mapGetters(['getACUResult', 'getOppaFile']),
        fileDownload: {
            get() {
                return this.getOppaFile
            }
        }
    },
    async mounted () {
        window.addEventListener('resize', this.onResize)
        this.opan_n = this.$route.query.OPPAN
        this.fetchSlip({
            OPPAN_PDF_NAME: this.opan_n,
            MEMBN: this.$cookies.get('usermembn')
        })
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['fetchSlip', 'getCsrfToken']),
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('DD MMMM YYYY')
        },
        goBack() {
            this.$router.push('/dashboard/annual-physical-exam')
        },
        getSlip() {
            const file = this.fileDownload
            const blob = base64ToBlob(file.file, 'application/pdf')
            // const url = URL.createObjectURL(blob)
            // console.log(url);
            saveAs(blob, `${this.getACUResult.OPAN_N}.pdf`)
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        }
    }
}
</script>
<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.memberInfoCard {
    width: 70%;
    margin: auto;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}

h1 {
    font-size: 18px;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
